import { CostCodeCategoryBase } from './base/cost-code-category-base';

export class CostCodeCategory extends CostCodeCategoryBase { }